'use client'

import * as React from 'react'
import { useEffect, useState } from 'react'
import { useIntercom } from 'react-use-intercom'
import { useAuthContext } from '~/features/auth/components/AuthProvider'

export function IntercomWrapper({ children }: { children: React.ReactNode }) {
  const { boot, shutdown, update, hardShutdown } = useIntercom()

  const { isLoaded, isSignedIn, user } = useAuthContext()
  const [isBooted, setIsBooted] = useState(false)

  useEffect(() => {
    setTimeout(() => {
      boot({
        hideDefaultLauncher: true,
      })
      setIsBooted(true)
    }, 0)
    return () => {
      hardShutdown()
    }
  }, [boot, shutdown])

  useEffect(() => {
    if (isBooted && isLoaded && isSignedIn) {
      update({
        userId: user.id,
        email: user.primaryEmailAddress?.emailAddress,
      })
    }
  }, [isLoaded, isSignedIn, user, isBooted])

  return <>{children}</>
}
